<div class="header">
   Saldo insuficiente
</div>
<div class="content">
   <img src="https://static.monific.com/assets/assets-app/img/icon/img/no_balance.svg" alt="" height="150" class="d-block m-auto">
   <h3 class="fw-bold text-center my-3 fs-26">¡Oh Oh!</h3>
   <p class="text-center cl-neutral-3 fs-14">
      Parece que no tienes saldo suficiente en tu cuenta.
   </p>

   <p class="text-center cl-neutral-3 fs-14 px-5">
      Puedes realizar un abono de
      <span class="cl-primary fw-sbold">{{ balanceNeeded | currency: '$' }}</span> a tu cuenta <strong>CLABE
         STP</strong> para la compra de
      <strong>{{ participationsToPurchase }}</strong>
      {{ participationsToPurchase === 1 ? 'participación' : 'participaciones' }} de
      <strong>{{ devName }}</strong>.
   </p>

   <div class="container-clabe">
      <div class="d-flex justify-content-between mb-2">
         <div>
            <p class="mb-0 fw-sbold cl-primary-3">CLABE</p>
            <p class="mb-0 fw-sbold info">{{ stp.clabe }}</p>
         </div>
         <img (click)="copyClabe()" height="20" class="my-auto" src="assets/icon/copy.svg" alt="">
      </div>

      <div class="mb-2">
         <p class="mb-0 fw-sbold cl-primary-3">Beneficiario</p>
         <p class="mb-1 cl-neutral-3">{{ name }}</p>
      </div>

      <div>
         <p class="mb-0 fw-sbold cl-primary-3">Banco receptor</p>
         <p class="mb-0 cl-neutral-3">STP</p>
      </div>
   </div>

   <div class="d-flex justify-content-around mt-4 mb-5">
      <button mat-button class="invert" (click)="closeModal()">
         No, en otro momento
      </button>
      <button mat-button class="" (click)="reloadPage()">
         Listo, ya he abonado
      </button>
   </div>
</div>
